import { mergeDeep } from '~environments/env.base';
import BRAND_BASE_CONFIG from './env.base';
import { EnvironmentType } from '@rccl/telemetry-events';

const environmentOverrides = {
  environment: {
    production: true,
    envName: 'prod.royal',
  },
  BRAND: 'royal',
  APIGEE_APP_KEY: 'cdCNc04srNq4rBvKofw1aC50dsdSaPuc',
  APIGEE_APP_KEY_MESSAGE_CENTER: 'IxXPQQ9zMH1sqEouOnoaCCPwDRPATiKo',
  APIGEE_APP_KEY_GQL: 'trL6t38bpvA5p65XlCrhFKzug8NNkqCD',
  LAUNCH_DARKLY_ENV_KEY: '5994aaf012b6db0bcb1d51cd',
  LAUNCH_DARKLY_SDK_KEY: 'sdk-8e9781d4-d176-4937-82aa-61b758a2da66',
  ESL_APP_KEY: 'CNZgDPOLqitHQqgkwhlhFKglSfZOSFrc',
  API_PATH: 'https://aws-prd.api.rccl.com',
  TEALIUM: {
    BRAND_CODE: 'postbooking-apps',
  },
  ADRUM: {
    APP_KEY: 'AD-AAB-ACK-YSW',
  },
  FORGEROCK_CONFIG: {
    urlConfig: {
      clientId: 'g9S023t74473ZUk909FN68F0b4N67PSOh92o04vL0BR6537pI2y2h94M6BbU7D6J',
      authId: 'W66846kPQv1750975oodH5M8zC6Ta7m30kH2Q78l2WmU50FCgqpP13w77377k7IB'
    }
  },
  TELEMETRY: {
    APP_ID: `Royal.${BRAND_BASE_CONFIG.TELEMETRY.APP_ID}`,
    APP_ENV: EnvironmentType.CLOUD_PROD,
    BATCH: {
      SIZE: 10,
      ENABLED: true,
    },
    DEBUG: {
      ENABLED: false,
      VERBOSE: false,
      CONSOLE_COLLAPSED: false,
    },
    TRACKING_URL:
      'https://aws-prd.api.rccl.com/en/royal/web/v1/ee/telemetry/events',
    ENDPOINTS: [],
    DISABLED: false,
  },
  WHITE_LIST_DOMAINS: [
    'https://www.royalcaribbean.com',
    'https://www.royalcaribbean.es',
    'https://www.royalcaribbean.com.au',
    'https://www.royalcaribbean.com.br',
    'https://www.royalcaribbean-espanol.com',
  ],
  ADVERTISEMENT: {
    BOARDING_PASS_PAGEID: '2209',
  },
  LOADER: 'assets/images/royal/loader.json',
  AEM_PATH: 'https://www.royalcaribbean.com/media-assets/pmc',
  PAYMENT: {
    APP_KEY: '32xNivqhfuEKNx1z1HVAbIGVt1QpGvnb',
  },
  BEACON_API: 'https://royalcaribbean.uat.koddi.io',
};

export default mergeDeep(BRAND_BASE_CONFIG, environmentOverrides);
